// extracted by mini-css-extract-plugin
module.exports = {"tiles":"tile_tiles__qpLOw"};